import type {
  PrismicDocument as OGPrismicDocument,
  PrismicDocumentWithUID,
  Query,
  RelationField,
} from "@prismicio/types"

import type { ContentLanguage, DocumentType } from "../enums"
import type { MakeMaybe } from "../graphql/queries"

export type UnassignedContentRelationship = { link_type: string }

type LinkedFields<TDocument extends BasePrismicDocument = never> =
  TDocument extends never ? undefined : keyof TDocument["data"]

export type DefinedContentRelationship<
  TDocument extends BasePrismicDocument = never,
  TFields extends LinkedFields<TDocument> = LinkedFields<TDocument>,
> = {
  id: string
  type: TDocument extends never ? undefined : `${TDocument["type"]}`
  tags: []
  slug: string
  lang: string
  uid: string
  link_type: string
  isBroken: boolean
  data?: TDocument extends never ? undefined : Pick<TDocument["data"], TFields>
}

export type ContentRelationship<
  TDocument extends OGPrismicDocument,
  TFields extends keyof TDocument["data"] = keyof TDocument["data"],
> = RelationField<
  `${TDocument["type"]}`,
  `${ContentLanguage}`,
  Pick<TDocument["data"], TFields>
>

export interface PrismicDocumentWithUid<
  T extends `${DocumentType}`,
  D extends PrismicDocumentWithUID["data"] = PrismicDocumentWithUID["data"],
> extends PrismicDocumentWithUID<D, T> {
  uid: string
}

export type PrismicDocumentSafe<
  T extends `${DocumentType}`,
  D extends PrismicDocumentWithUID["data"],
> = OGPrismicDocument<MakeMaybe<D, keyof D>, T>

export type PrismicDocumentWithUidSafe<
  T extends `${DocumentType}`,
  D extends PrismicDocumentWithUID["data"],
> = PrismicDocumentWithUID<MakeMaybe<D, keyof D>, T>

export type PrismicDocWithSelectedData<
  TDocument extends PrismicDocumentWithUid<DocumentType>,
  TDataKeys extends keyof TDocument["data"],
> = Omit<TDocument, "data"> & { data: Pick<TDocument["data"], TDataKeys> }

export type BasePrismicDocument = OGPrismicDocument<
  OGPrismicDocument["data"],
  `${DocumentType}`
>

export type PrismicSearchResponse<T extends BasePrismicDocument> = Query<T>

export * from "./about-page"
export * from "./article"
export * from "./author"
export * from "./category"
export * from "./color-scheme"
export * from "./contribute-page"
export * from "./data-page"
export * from "./newsletter"
export * from "./podcast"
export * from "./privacy-policy"
